import React from "react";
import { Helmet } from "react-helmet";

const ProfileHelmet = ({ user: { name, picture }, profilePath }) => (
  <Helmet>
    <title>{name} | Casemasters</title>
    <meta
      name="description"
      content={`View ${name}'s dental cases on Casemasters. Casemasters is the world's largest network for dental professionals to showcase and discover great dental work.`}
    />
    <meta property="og:title" content={`${name} | Casemasters`} />
    <meta
      property="og:description"
      content={`View ${name}'s dental cases on Casemasters. Casemasters is the world's largest network for dental professionals to showcase and discover great dental work.`}
    />
    <meta property="og:image" content={picture} />
    <meta property="og:image:type" content="image/png" />
    <meta property="og:url" content={`https://www.casemasters.com${profilePath}`} />
  </Helmet>
);

export default ProfileHelmet;



// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/components/ProfileHelmet.js